import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import type { KambiGroup } from '@mobi/api-types/kambi'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'

const sportsRootInitialState: SportsRootState = {
  favouriteSports: [],
  favouriteMarkets: {},
  favouriteCompetitions: [],
}

const sportsRootSlice = createSlice({
  name: 'sports-root',
  initialState: sportsRootInitialState,
  reducers: {
    toggleSportMarketsFavourite(
      state,
      { payload }: PayloadAction<{ sportName: KambiSportName; criterionLabel: string }>
    ) {
      let list = state.favouriteMarkets[payload.sportName] || []
      if (list.includes(payload.criterionLabel)) {
        list = list.filter(item => item !== payload.criterionLabel)
      } else {
        list.push(payload.criterionLabel)
      }
      state.favouriteMarkets[payload.sportName] = list
    },

    toggleFavourite(state, { payload }: PayloadAction<Favourite>) {
      switch (payload.eventGroupType) {
        case 'sport':
          if (state.favouriteSports.some(item => item.id === payload.id)) {
            state.favouriteSports = state.favouriteSports.filter(item => item.id !== payload.id)
          } else {
            state.favouriteSports.push(payload)
          }
          break
        case 'competition':
          if (state.favouriteCompetitions.some(item => item.id === payload.id)) {
            state.favouriteCompetitions = state.favouriteCompetitions.filter(
              item => item.id !== payload.id
            )
          } else {
            state.favouriteCompetitions.push(payload)
          }
          break
      }
    },
  },
})

export const { toggleSportMarketsFavourite, toggleFavourite } = sportsRootSlice.actions

const persistAllowList: (keyof SportsRootState)[] = [
  'favouriteCompetitions',
  'favouriteMarkets',
  'favouriteSports',
]

export default persistReducer(
  {
    key: 'sports-root',
    storage,
    // debug: !PRODUCTION,
    whitelist: persistAllowList,
  },
  sportsRootSlice.reducer
)

// =====
// Types
// =====

/** criterion label for each sport */
type FavouriteKambiMarket = Partial<Record<KambiSportName, string[]>>

type FavouriteBase = Pick<KambiGroup, 'id' | 'name' | 'sport'> & { path: string }
type FavouriteSport = FavouriteBase & { eventGroupType: 'sport' }
type FavouriteCompetition = FavouriteBase & { eventGroupType: 'competition' }
type Favourite = FavouriteSport | FavouriteCompetition

export interface SportsRootState {
  favouriteMarkets: FavouriteKambiMarket
  favouriteSports: FavouriteSport[]
  favouriteCompetitions: Favourite[]
}
